import React from 'react';
import styled from 'styled-components';
import tw from 'tailwind.macro';

import openIcon from '../images/icon_card-blanco.png';
import open24hIcon from '../images/icon_card-24h.png';

export default ({ local, onSelectNearLocal }) => {
  const distance = `${parseFloat(local.distanceFromPoint).toFixed(1)} kms`;
  const chooseIcon = (local) => {
    if (local.is24h) {
      return local.abierto ? open24hIcon : close24hIcon;
    }
    return openIcon;
  };

  const handleClick = (e) => {
    e.stopPropagation();
    onSelectNearLocal(local.local);
  };

  return (
    <Local onClick={handleClick}>
      <Icon src={chooseIcon(local)} />
      <AddressContainer>
        <Address>
          {local.direccion}
        </Address>
      </AddressContainer>
      <Distance>
        {distance}
      </Distance>
    </Local>
  );
};

const Local = styled.div`
  background-color: #7BBC57;
  ${tw`
    my-4 text-left flex items-center overflow-auto text-white font-medium text-xs p-2
    cursor-pointer
  `}
`;

const AddressContainer = styled.div`
  ${tw`w-64 mx-4 flex-1`}
`;

const Address = styled.div`
  ${tw`break-words`}
`;

const Distance = styled.div`
  ${tw`text-right`}
`;

const Icon = styled.img`
  ${tw`ml-2 w-4`}
`;
